import axios from "axios";
import { toast } from "react-toastify";
import { DataResult } from "@progress/kendo-data-query";
import { DockForFtlRouteViewModel } from "../../../../ViewModel/DockForFtlRouteViewModel";
import commandDeleteRow from "../../../../../Grid/ControlColumn/CommandDeleteRow";
import { combinedUrls } from "../../../../../URL/functions";
import { projectUrls } from "../../../../../URL/ApplicationUrls";

export const deletePlantDockOnClick = async (
  dataItem: DockForFtlRouteViewModel,
  ftlRouteId: number,
  idField: string,
  dataResult: DataResult,
  onDataResultChanged: (dataResult: DataResult) => void,
  projectId?: number
) => {
  const { DockId, PlantGsdb, DockCode } = dataItem;

  async function deletePlantDock() {
    const url = combinedUrls(
      projectUrls.base.apiUrl,
      `/${ftlRouteId}/DeleteDock/${DockId}`
    );

    const response = await axios.delete(url);

    if (response.status !== 200) {
      throw new Error("Network response was not ok");
    }

    const json: any = response.data;
    if (!json.Success) {
      throw new Error(`Receive Response, but got Error: ${json.ErrorMessage}`);
    }
    commandDeleteRow({
      idField,
      dataResult,
      setDataResult: onDataResultChanged,
      dataItem,
    });
  }

  await toast.promise(deletePlantDock(), {
    pending: "Pending",
    error: {
      render({ data }: { data: any }) {
        return data?.message;
      },
    },
    success: `${PlantGsdb}.${DockCode} has been deleted`,
  });
};
